import React from 'react';
import './PlayerBonusToggle.css';
import {getPlayerBonusConfig, PLAYER_BONUS_LABELS, PLAYER_BONUS_TYPES} from "../../configs/playerBonus";
import {getPlayerBonusLines} from "../../utils/players/getPlayerBonusLines";
import {addClassNameIfTrue} from "../../utils/other/addClassNameIfTrue";

/**
 * Кнопка уровня экономического бонуса (см. configs/playerBonus): «Бонус: …»,
 * каждое нажатие — следующий уровень по кругу (onCycle). Общая для настройки
 * локальной игры (бонус каждому игроку) и обычного сетевого лобби (один бонус
 * на всех игроков лобби).
 *
 * tooltipText — пояснение, к которому в подсказке добавляется расшифровка
 * выбранного уровня. Без onCycle кнопка только показывает уровень (например,
 * участнику лобби, который бонус не выбирает).
 */
const PlayerBonusToggle = ({bonus, onCycle, tooltipText, className = ''}) => {
  const bonusType = bonus || PLAYER_BONUS_TYPES.NONE;
  const isActive = bonusType !== PLAYER_BONUS_TYPES.NONE;
  const isReadOnly = !onCycle;

  // Форматтер общий с подсказкой значка «явного» бота — расшифровка бонуса
  // должна выглядеть одинаково во всех местах
  const tooltip = isActive
    ? `${tooltipText}\n${getPlayerBonusLines(getPlayerBonusConfig(bonusType)).join('\n')}`
    : tooltipText;

  return (
    <button
      type="button"
      className={`player-bonus-toggle ${addClassNameIfTrue(isActive, 'player-bonus-toggle_active')} ${
        addClassNameIfTrue(isReadOnly, 'player-bonus-toggle_read-only')
      } ${className}`}
      onClick={isReadOnly ? undefined : onCycle}
      // Не disabled: у отключенной кнопки подсказка по наведению показывается
      // не во всех браузерах, а расшифровку бонуса участнику лобби видеть нужно
      aria-disabled={isReadOnly || undefined}
      title={tooltip}
    >
      <img className="player-bonus-info-icon" src="/img/icons/info.png" alt="info"/>
      <span>Бонус: {PLAYER_BONUS_LABELS[bonusType] || PLAYER_BONUS_LABELS[PLAYER_BONUS_TYPES.NONE]}</span>
    </button>
  );
};

export default PlayerBonusToggle;
